import { CommonModule } from "@angular/common";
import { Component, computed, Inject, OnDestroy, OnInit, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ImportWizardStep, ImportWizardStorage, ImportWizardType } from "./import-wizard.storage";
import { ImportWizardService } from "./import-wizard.service";
import { ImportWizardGeospatialComponent } from "./components/geospatial/import-wizard-geospatial.component";
import { ImportWizardTabularComponent } from "./components/tabular/import-wizard-tabular.component";
import { ImportWizardPendingListComponent } from "./components/pending-list/import-wizard-pending-list.component";
import { AlertComponent } from "src/app/shared/alert/alert.component";
import { ImportWizardPendingService } from "./components/pending-list/import-wizard-pending-list.service";
import { DatasetType } from "@/app/dtos/import-wizard/import-wizard.dto";
import { ImportWizardPendingStorage } from "./components/pending-list/import-wizard-pending-list.storage";
import { forkJoin } from "rxjs";

@Component({
  selector: 'app-import-wizard',
  templateUrl: './import-wizard.component.html',
  styleUrls: ['./import-wizard.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ImportWizardGeospatialComponent,
    ImportWizardTabularComponent,
    ImportWizardPendingListComponent,
    AlertComponent
  ],
  providers: [
    // Router,
    ImportWizardPendingService
    // MatDialog,
  ],
  standalone: true
})
export class ImportWizardComponent implements OnInit, OnDestroy {
  // file = signal<File | null>(null);
  repositoryId = signal<string | null>(null);

  type = computed(() => this.importWizardStorage.type());

  isHasMappingChangesAlertOpen = signal<boolean>(false);

  constructor(
      private router: Router,
      private dialog: MatDialog,
      private importWizardStorage: ImportWizardStorage,
      private importWizardService: ImportWizardService,
      public dialogRef: MatDialogRef<ImportWizardComponent>,
      private importWizardPendingService: ImportWizardPendingService,
      private importWizardPendingStorage: ImportWizardPendingStorage,
      // @Inject(MAT_DIALOG_DATA) public data: {formData: any},
  ) { }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.listenDialogClose();
  }

  private listenDialogClose() {
    this.dialogRef.backdropClick().subscribe(() => {
      this.tryCloseWizard();
    });

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.tryCloseWizard();
      }
    });
  }

  private tryCloseWizard() {
    const hasChanges =
      this.importWizardStorage.step() === ImportWizardStep.MAPPING_ADJUSTS &&
      this.importWizardStorage.mappingHasChanges();

    if (hasChanges) {
      this.isHasMappingChangesAlertOpen.set(true); 
      return;
    }

    this.dialogRef.close();
  }

  handleClose() {
    this.tryCloseWizard();
  }

  handleOpenHasMappingChangersAlert() {
    this.isHasMappingChangesAlertOpen.set(true);
  }

  handleHasMappingChangersAlertConfirm() {
    this.isHasMappingChangesAlertOpen.set(false);
    this.dialogRef.close();
  }

  handleHasMappingChangersAlertCancel() {
    this.isHasMappingChangesAlertOpen.set(false);
  }

  private handleOnDestroyRefetch(): void {
      forkJoin({
          tabular: this.importWizardPendingService.useGetAllPendingImports(DatasetType.TABULAR),
          spatial: this.importWizardPendingService.useGetAllPendingImports(DatasetType.SPATIAL),
      }).subscribe({
          next: ({ tabular, spatial }) => {
              this.importWizardPendingStorage.setPendingImports([...tabular, ...spatial]);
          },
          error: (err) => {
              console.error('[handleOnDestroyRefetch] Erro ao buscar imports pendentes:', err);
          }
      });
  }

  ngOnDestroy(): void {
    this.handleOnDestroyRefetch();
    this.importWizardStorage.reset();
  }

  ImportWizardType = ImportWizardType;
}